import React, { useState } from 'react';
import './css/ViralClips.css';

const ViralClips = ({ clips, isLoading = false, totalExpected = 3 }) => {
  const [selectedClip, setSelectedClip] = useState(null);
  // Remove or comment out console logs in production code
  // console.log("clips============>",clips);
  
  const handleClipClick = (index) => {
    setSelectedClip(index === selectedClip ? null : index);
  };

  const handleDownload = (clip, e) => {
    e.stopPropagation(); // Prevent triggering the card click
    // In a real implementation, this would trigger a download of the clip
    window.open(clip.downloadUrl, '_blank');
  };

  const handleShare = (clip, platform, e) => {
    e.stopPropagation(); // Prevent triggering the card click
    // In a real implementation, this would share the clip to the selected platform
    alert(`Sharing clip: ${clip.title} to ${platform}`);
  };

  return (
    <div className="viral-clips">
      <h2>Top {totalExpected} Viral Clips</h2>
      
      {/* Horizontal clips container */}
      <div className="clips-container-horizontal">
        {isLoading && (
          <div className="loading-message">
            Loading clips... {clips ? `${clips.length}/${totalExpected} clips ready` : ''}
          </div>
        )}
        
        {clips && clips.length > 0 ? clips.map((clip, index) => (
          // Remove console.log from JSX rendering
          <div
            key={index}
            className={`clip-card-horizontal ${selectedClip === index ? 'expanded' : ''}`}
            onClick={() => handleClipClick(index)}
          >
            <div className="clip-preview-horizontal">
              <div className="video-container">
                <video controls preload="metadata" poster={clip.thumbnailUrl || ''}>
                  <source src={clip.downloadUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="clip-info-horizontal">
                {/* <h3>{clip.title}</h3> */}
                {/* <div className="clip-stats-horizontal">
                  <span>Viral Score: {clip.viralScore}/10</span>
                  <span>Duration: {clip.duration}s</span>
                </div> */}
                <p className="clip-description">{clip.description}</p>
                
                <div className="clip-actions-horizontal">
                  <button 
                    className="download-button" 
                    onClick={(e) => handleDownload(clip, e)}
                  >
                    Download
                  </button>
                  {/* <div className="share-buttons-horizontal">
                    <button onClick={(e) => handleShare(clip, 'TikTok', e)}>
                      <span className="platform-icon">📱</span> TikTok
                    </button>
                    <button onClick={(e) => handleShare(clip, 'Instagram', e)}>
                      <span className="platform-icon">📷</span> Instagram
                    </button>
                    <button onClick={(e) => handleShare(clip, 'YouTube', e)}>
                      <span className="platform-icon">🎬</span> YouTube
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
            
            {selectedClip === index && (
              <div className="clip-insights-horizontal">
                <h4>AI Insights</h4>
                <ul>
                  {clip.insights.map((insight, i) => (
                    <li key={i}>{insight}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )) : (
          !isLoading && <div className="no-clips-message">No viral clips available at the moment.</div>
        )}
      </div>
    </div>
  );
};

export default ViralClips;